// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile {
    margin: 0 var(--space-x3);
    display: grid;
    grid-template-areas: ". left left left center center center center center . right right";
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);
    padding-bottom: var(--space-x3);
}

.profile__left-container {
    /* grid-area: left; */
}
.profile__left-container__info {
    margin: var(--space-x2-and-half) 0 0;
}

.profile__right-container {
    /* grid-area: right; */
    grid-column-start: 10;
    grid-column-end: 13;
}
.profile__right-container__title {
    margin-top: var(--space-x3);
}
.profile__right-container__subtitle {
    margin-top: var(--space-x2);
}
.profile__right-container__profile-suggestions {
    margin-top: var(--space-x2);
}
.profile__right-container__pages-suggestions {
    margin-top: var(--space-x2);
}

.profile__left-container__my-pages-info {
    margin: var(--space-x2) 0;
}

.profile__left-container__my-pages {
    margin: var(--space);
}

.profile__center-container {
    /* grid-area: center; */
    grid-column-start: 2;
    grid-column-end: 9;
}

.profile__center-container.unauth {
    /* grid-area: center; */
    grid-column-start: 3;
    grid-column-end: 11;
}
.profile__center-container__tabs {
    /* margin-top: var(--space-x2-and-half); */
    background-color: var(--white-color);
}

.profile__center-container__tabs .MuiTab-root.Mui-selected *{
    color: var(--primary-dark-color) !important;
}
/* .profile__center-container__tabs .PrivateTabIndicator-root-1{
    width: 30% !important;
    margin-left: calc(var(--space-x3) + var(--space));
} */

.profile__center-container__tabs .MuiTab-wrapper {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);/*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
    text-transform: none;
}


.profile__completion {
    margin-top: var(--space-and-half);
}
.profile__technics {
    margin-top: var(--space-and-half);
}
.profile__skills {
    margin-top: var(--space-and-half);
}
.profile__experiences {
    margin-top: var(--space-and-half);
}
.profile__specialties {
    margin-top: var(--space-and-half);
}
.profile__aptitudes {
    margin-top: var(--space-and-half);
}
.profile__interests {
    margin-top: var(--space-and-half);
}

.MuiSkeleton-root.MuiSkeleton-rect.my-pages__suggestion.MuiSkeleton-wave{
    height: 3em;
}

.MuiSkeleton-root.MuiSkeleton-rect.profile-info__photo_skeleton.MuiSkeleton-wave {
    width: 50%;
    padding-top: 50%;
    margin: 0 auto;
    position: relative;
    display: flex;
    overflow: hidden;
    border-radius: 8px;
}

.MuiSkeleton-text.profile-info__username, .MuiSkeleton-text.profile-info__fullname{
    margin-top: var(--space-and-half);
    transform: none;
}

.profile__teams {
    margin-top: var(--space-and-half);
}

.profile__information-type__btns-container {
    display: flex;
    align-items: center;
    padding: 24px 16px;
    gap: 16px;
    background-color: var(--white-color);
}

.profile__information-type__btns-container .baloa-table-column {
    border-radius: 25px;
    border: 2px solid var(--new-green-color);
    padding: 8px 20px;
    color: var(--new-green-color);
    cursor: pointer;
}

.profile__information-type__btns-container .baloa-table-column.selected {
    color: var(--white-color);
    background-color: var(--new-green-color);
}

.profile__center-container .baloa-pro-subscription-widget__container {
    margin-bottom: var(--space-half);
    padding: var(--space) var(--space-and-half);
    border: none;
    margin-top: var(--space-half);
}

@media screen and ( min-width: 1600px ) {
    .profile {
        gap: 60px;
    }
}

@media screen and ( max-width: 768px ) {

    .profile {
        margin: 0;
        margin-top: var(--space-and-half);
        grid-template-areas: "left"
                             "center";
        grid-template-columns: 100%;
        gap: var(--space-half);
    }

    .profile__center-container.unauth {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .profile__center-container__tabs {
        margin-top: var(--space-and-half);
    }

    .profile__left-container__info {
        margin: 0;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .profile {
        display: block;
        margin-top: var(--space-x2);
    }

    .profile__center-container__tabs {
        margin-top: 10px;
    }

    .profile__left-container__info {
        margin: 0;
    }
    
    .profile__teams, 
    .profile__experiences,
    .profile__specialties,
    .profile__aptitudes,
    .profile__interests {
        margin-left: var(--space);
        margin-right: var(--space);
        margin-top: var(--space-half-quarter);
        border-radius: var(--space-half-quarter);
    }

    .profile__center-container .baloa-pro-subscription-widget__container {
        padding: 12px;
        margin: 10px 8px;
        border: solid 1px var(--new-gray-background-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/views/ProfileView.styles.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,aAAa;IACb,wFAAwF;IACxF,sCAAsC;IACtC,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;AACA;;;GAGG;;AAEH;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;IAC3C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;AACxB;;;AAGA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,2CAA2C;IAC3C,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI;QACI,SAAS;QACT,iCAAiC;QACjC;qCAC6B;QAC7B,2BAA2B;QAC3B,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;;;;;QAKI,yBAAyB;QACzB,0BAA0B;QAC1B,qCAAqC;QACrC,wCAAwC;IAC5C;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,kDAAkD;IACtD;AACJ","sourcesContent":["\n.profile {\n    margin: 0 var(--space-x3);\n    display: grid;\n    grid-template-areas: \". left left left center center center center center . right right\";\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);\n    padding-bottom: var(--space-x3);\n}\n\n.profile__left-container {\n    /* grid-area: left; */\n}\n.profile__left-container__info {\n    margin: var(--space-x2-and-half) 0 0;\n}\n\n.profile__right-container {\n    /* grid-area: right; */\n    grid-column-start: 10;\n    grid-column-end: 13;\n}\n.profile__right-container__title {\n    margin-top: var(--space-x3);\n}\n.profile__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n.profile__right-container__profile-suggestions {\n    margin-top: var(--space-x2);\n}\n.profile__right-container__pages-suggestions {\n    margin-top: var(--space-x2);\n}\n\n.profile__left-container__my-pages-info {\n    margin: var(--space-x2) 0;\n}\n\n.profile__left-container__my-pages {\n    margin: var(--space);\n}\n\n.profile__center-container {\n    /* grid-area: center; */\n    grid-column-start: 2;\n    grid-column-end: 9;\n}\n\n.profile__center-container.unauth {\n    /* grid-area: center; */\n    grid-column-start: 3;\n    grid-column-end: 11;\n}\n.profile__center-container__tabs {\n    /* margin-top: var(--space-x2-and-half); */\n    background-color: var(--white-color);\n}\n\n.profile__center-container__tabs .MuiTab-root.Mui-selected *{\n    color: var(--primary-dark-color) !important;\n}\n/* .profile__center-container__tabs .PrivateTabIndicator-root-1{\n    width: 30% !important;\n    margin-left: calc(var(--space-x3) + var(--space));\n} */\n\n.profile__center-container__tabs .MuiTab-wrapper {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);/*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n    text-transform: none;\n}\n\n\n.profile__completion {\n    margin-top: var(--space-and-half);\n}\n.profile__technics {\n    margin-top: var(--space-and-half);\n}\n.profile__skills {\n    margin-top: var(--space-and-half);\n}\n.profile__experiences {\n    margin-top: var(--space-and-half);\n}\n.profile__specialties {\n    margin-top: var(--space-and-half);\n}\n.profile__aptitudes {\n    margin-top: var(--space-and-half);\n}\n.profile__interests {\n    margin-top: var(--space-and-half);\n}\n\n.MuiSkeleton-root.MuiSkeleton-rect.my-pages__suggestion.MuiSkeleton-wave{\n    height: 3em;\n}\n\n.MuiSkeleton-root.MuiSkeleton-rect.profile-info__photo_skeleton.MuiSkeleton-wave {\n    width: 50%;\n    padding-top: 50%;\n    margin: 0 auto;\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    border-radius: 8px;\n}\n\n.MuiSkeleton-text.profile-info__username, .MuiSkeleton-text.profile-info__fullname{\n    margin-top: var(--space-and-half);\n    transform: none;\n}\n\n.profile__teams {\n    margin-top: var(--space-and-half);\n}\n\n.profile__information-type__btns-container {\n    display: flex;\n    align-items: center;\n    padding: 24px 16px;\n    gap: 16px;\n    background-color: var(--white-color);\n}\n\n.profile__information-type__btns-container .baloa-table-column {\n    border-radius: 25px;\n    border: 2px solid var(--new-green-color);\n    padding: 8px 20px;\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.profile__information-type__btns-container .baloa-table-column.selected {\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n}\n\n.profile__center-container .baloa-pro-subscription-widget__container {\n    margin-bottom: var(--space-half);\n    padding: var(--space) var(--space-and-half);\n    border: none;\n    margin-top: var(--space-half);\n}\n\n@media screen and ( min-width: 1600px ) {\n    .profile {\n        gap: 60px;\n    }\n}\n\n@media screen and ( max-width: 768px ) {\n\n    .profile {\n        margin: 0;\n        margin-top: var(--space-and-half);\n        grid-template-areas: \"left\"\n                             \"center\";\n        grid-template-columns: 100%;\n        gap: var(--space-half);\n    }\n\n    .profile__center-container.unauth {\n        grid-column-start: 1;\n        grid-column-end: 2;\n    }\n\n    .profile__center-container__tabs {\n        margin-top: var(--space-and-half);\n    }\n\n    .profile__left-container__info {\n        margin: 0;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .profile {\n        display: block;\n        margin-top: var(--space-x2);\n    }\n\n    .profile__center-container__tabs {\n        margin-top: 10px;\n    }\n\n    .profile__left-container__info {\n        margin: 0;\n    }\n    \n    .profile__teams, \n    .profile__experiences,\n    .profile__specialties,\n    .profile__aptitudes,\n    .profile__interests {\n        margin-left: var(--space);\n        margin-right: var(--space);\n        margin-top: var(--space-half-quarter);\n        border-radius: var(--space-half-quarter);\n    }\n\n    .profile__center-container .baloa-pro-subscription-widget__container {\n        padding: 12px;\n        margin: 10px 8px;\n        border: solid 1px var(--new-gray-background-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
